import ODataServiceStrategy from './ODataServiceStrategy';

/**
 * A query service strategy class. It has services to create OData 2 query strings.
 */
class OData2ServiceStrategy extends ODataServiceStrategy {
  /**
   * Format to OData DateTime.
   * @param Date is a string of type 'YYYY-MM-DD'.
   * @protected
   */
  // eslint-disable-next-line class-methods-use-this
  formatDateTime = (date) => `datetime'${date}'`;
}

const ODATA_2_QUERY_SERVICE_STATEGY = new OData2ServiceStrategy();

export default ODATA_2_QUERY_SERVICE_STATEGY;
